const getCarouselVisibleItemCount = (containerWidth: number, scrollStep: number) =>
  Math.max(1, Math.floor(containerWidth / scrollStep));

export const getCarouselPageCount = (
  containerWidth: number,
  itemCount: number,
  scrollStep: number
) => {
  if (itemCount <= 0) {
    return 0;
  }

  const visibleCount = getCarouselVisibleItemCount(containerWidth, scrollStep);
  return Math.max(1, itemCount - visibleCount + 1);
};

export const getCarouselMaxScrollLeft = (scrollWidth: number, clientWidth: number) =>
  Math.max(0, scrollWidth - clientWidth);

export const getCarouselScrollLeftForPage = (
  pageIndex: number,
  scrollStep: number,
  maxScrollLeft: number
) => Math.min(Math.max(pageIndex, 0) * scrollStep, maxScrollLeft);

export const getCarouselPageFromScrollLeft = (
  scrollLeft: number,
  scrollStep: number,
  maxPageIndex: number,
  maxScrollLeft = maxPageIndex * scrollStep
) => {
  if (maxPageIndex <= 0) {
    return 0;
  }

  let closestPage = 0;
  let closestDistance = Number.POSITIVE_INFINITY;

  for (let page = 0; page <= maxPageIndex; page += 1) {
    const pageScrollLeft = getCarouselScrollLeftForPage(page, scrollStep, maxScrollLeft);
    const distance = Math.abs(scrollLeft - pageScrollLeft);

    if (distance < closestDistance) {
      closestDistance = distance;
      closestPage = page;
    }
  }

  return closestPage;
};
